<template>
	<home-tile v-if="!hasAccounts" color="cerulean">
		<img class="tile-image" src="@/assets/enableRoundups.svg" />
		<h3 class="tile-header">Almost Done!</h3>
		<div style="padding: 0 30px">
			<span class="tile-text-small"
				>Authorize round ups with the bank that issued your card.<br
			/></span>
			<span class="tile-text-small"
				>Your minimum will be donated until your round ups are
				authorized.</span
			>
		</div>
		<template slot="button">
			<plaid-link
				v-bind="{
					publicKey,
					env,
					webhook,
					clientName,
					onSuccess,
					token: linkToken
				}"
			>
				Authorize Round Ups
			</plaid-link>
		</template>
	</home-tile>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import PlaidLink from 'vue-plaid-link'
import HomeTile from './HomeTile'

export default {
	name: 'roundups-tile',
	components: { HomeTile, PlaidLink },
	data() {
		return {
			publicKey: process.env.VUE_APP_PLAID_PUBLIC_KEY,
			env: process.env.VUE_APP_PLAID_ENV,
			webhook: process.env.VUE_APP_PLAID_WEBHOOK,
			clientName: 'RoundUp App',
			link: null,
			linkToken: null
		}
	},
	computed: {
		...mapGetters(['hasAccounts'])
	},
	methods: {
		...mapActions(['getHome', 'attachLink', 'fetchLinkToken']),
		onSuccess(token, metadata) {
			const params = {
				public_token: token,
				institution_id: metadata.institution.institution_id,
				institution_name: metadata.institution.name
			}
			this.attachLink(params)
		}
	},
	mounted() {
		this.fetchLinkToken()
			.then((resp) => {
				this.linkToken = resp.link_token
			})
			.catch((error) => this.$swal('Error', error.message))
	}
}
</script>

<style lang="scss"></style>
